import { combineReducers } from "@reduxjs/toolkit"

import specialistSlice from "../specialist-slices/auth.slice"
import walletSlice from "../specialist-slices/wallet.slice"
import memberSlice from "../member-slices/auth.slice"
import socketSlice from "../user-slices/socket.slice"
import otherSlice from "../guest-slices/other.slice"
import authSlice from "../user-slices/auth.slice"
import subscriptionSlice from "../user-slices/subscription.slice"

const rootReducer = combineReducers({
  authSlice,
  otherSlice,
  memberSlice,
  socketSlice,
  specialistSlice,
  walletSlice,
  subscriptionSlice
})

export default rootReducer